// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// interface AuthState {
//   loading: boolean;
//   isAuthenticated: boolean;
//   error: string | null;
//   user: { username: string; password: string } | null;
// }
// const initialState: AuthState = {
//   loading: false,
//   isAuthenticated: false,
//   error: null,
//   user: null,
// };
// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     loginRequest(
//       state,
//       action: PayloadAction<{ username: string; password: string }>
//     ) {
//       state.loading = true;
//       state.error = null;
//     },
//     loginSuccess(
//       state,
//       action: PayloadAction<{ username: string; password: string }>
//     ) {
//       state.loading = false;
//       state.isAuthenticated = true;
//       state.user = action.payload;
//     },
//     loginFailure(state, action: PayloadAction<string>) {
//       state.loading = false;
//       state.isAuthenticated = false;
//       state.error = action.payload;
//     },
//   },
// });
// export const { loginRequest, loginSuccess, loginFailure } = authSlice.actions;
// export default authSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  loading: boolean;
  isAuthenticated: boolean;
  user: any | null;
  error: string | null;
}

// const initialState: AuthState = {
//   loading: false,
//   isAuthenticated: false,
//   user: null,
//   error: null,
// };

const initialState: any = { login: { isloading: false } };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.isAuthenticated = true;
      state.error = null;
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    otpRequest(state) {
      state.loading = true;
      state.error = null;
    },
    otpSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.isOtpVerified = true;
      state.error = null;
    },
    otpFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.isOtpVerified = false;
      state.error = action.payload;
    },
    logoutSuccess(state) {
      state.isLoggedIn = false;
      state.user = null;
    },
    logoutFailure(state, action) {
      state.error = action.payload;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  otpRequest,
  otpSuccess,
  otpFailure,
  logoutSuccess,
  logoutFailure
} = authSlice.actions;
export default authSlice.reducer;
